import { fromJS } from 'immutable';
//@ts-expect-error missing types
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
const formatCosIndexObject = cosIndexObjectsResponse => Object.entries(cosIndexObjectsResponse).map(([id, matchingCosIndexObjects]) => new ReferenceRecord({
  id,
  label: matchingCosIndexObjects.map(({
    label
  }) => label).join(', '),
  referencedObject: fromJS(matchingCosIndexObjects)
}));
export default formatCosIndexObject;